import { BubbleColor, Bubble } from 'js/bubbleCore/bubbles/types';

const colorMap: {[key in BubbleColor]: number} = {
  [BubbleColor.A]: 0x1c94ea,
  [BubbleColor.B]: 0x3ae21c,
  [BubbleColor.C]: 0xFF8400,
  [BubbleColor.D]: 0xfc401b,
  [BubbleColor.E]: 0xCDD8DE,
  [BubbleColor.F]: 0xDC3FC5,
  [BubbleColor.NONE]: 0xffffff,
}

export function getColorForBubble(bubble: Bubble): number {
  return colorMap[bubble.core.color];
}